/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AgentToolsV2Service {
  /**
   * @summary Plan Resolve Endpoint
   * @description Resolve the caller's words into a bookable service.
   */
  planResolveEndpointAgentToolV2PlanResolvePost: {
    /**
     * @summary Plan Resolve Endpoint
     * @description Resolve the caller's words into a bookable service.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        PlanResolveEndpointAgentToolV2PlanResolvePostBody,
        PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
        options: ServiceOperationMutationFnOptions<
          PlanResolveEndpointAgentToolV2PlanResolvePostBody,
          PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          PlanResolveEndpointAgentToolV2PlanResolvePostData,
          PlanResolveEndpointAgentToolV2PlanResolvePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        PlanResolveEndpointAgentToolV2PlanResolvePostData,
        PlanResolveEndpointAgentToolV2PlanResolvePostError
      >
    >;
    /**
     * @summary Plan Resolve Endpoint
     * @description Resolve the caller's words into a bookable service.
     */
    getMutationKey(
      parameters: DeepReadonly<PlanResolveEndpointAgentToolV2PlanResolvePostParameters> | void
    ): ServiceOperationMutationKey<
      PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
      PlanResolveEndpointAgentToolV2PlanResolvePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Plan Resolve Endpoint
     * @description Resolve the caller's words into a bookable service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends PlanResolveEndpointAgentToolV2PlanResolvePostBody, TContext = unknown>(
      parameters: DeepReadonly<PlanResolveEndpointAgentToolV2PlanResolvePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
        PlanResolveEndpointAgentToolV2PlanResolvePostData,
        PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
        TVariables,
        OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
        TContext
      >
    ): UseMutationResult<
      PlanResolveEndpointAgentToolV2PlanResolvePostData,
      OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Plan Resolve Endpoint
     * @description Resolve the caller's words into a bookable service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        PlanResolveEndpointAgentToolV2PlanResolvePostBody,
        PlanResolveEndpointAgentToolV2PlanResolvePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
        PlanResolveEndpointAgentToolV2PlanResolvePostData,
        PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
        TVariables,
        OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
        TContext
      >
    ): UseMutationResult<
      PlanResolveEndpointAgentToolV2PlanResolvePostData,
      OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Plan Resolve Endpoint
     * @description Resolve the caller's words into a bookable service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const planResolveEndpointAgentToolV2PlanResolvePostTotal = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const planResolveEndpointAgentToolV2PlanResolvePostTotal = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PlanResolveEndpointAgentToolV2PlanResolvePostBody,
            PlanResolveEndpointAgentToolV2PlanResolvePostData,
            PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
            OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
            PlanResolveEndpointAgentToolV2PlanResolvePostBody,
            PlanResolveEndpointAgentToolV2PlanResolvePostData,
            PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
            OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Plan Resolve Endpoint
     * @description Resolve the caller's words into a bookable service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const planResolveEndpointAgentToolV2PlanResolvePostPendingMutationVariables = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const planResolveEndpointAgentToolV2PlanResolvePostMutationData = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PlanResolveEndpointAgentToolV2PlanResolvePostData,
        OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
        MutationVariables<
          PlanResolveEndpointAgentToolV2PlanResolvePostBody,
          PlanResolveEndpointAgentToolV2PlanResolvePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PlanResolveEndpointAgentToolV2PlanResolvePostBody,
            PlanResolveEndpointAgentToolV2PlanResolvePostData,
            PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
            OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
            PlanResolveEndpointAgentToolV2PlanResolvePostBody,
            PlanResolveEndpointAgentToolV2PlanResolvePostData,
            PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
            OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PlanResolveEndpointAgentToolV2PlanResolvePostData,
          OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
          MutationVariables<
            PlanResolveEndpointAgentToolV2PlanResolvePostBody,
            PlanResolveEndpointAgentToolV2PlanResolvePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Plan Resolve Endpoint
     * @description Resolve the caller's words into a bookable service.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PlanResolveEndpointAgentToolV2PlanResolvePostBody,
            PlanResolveEndpointAgentToolV2PlanResolvePostData,
            PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
            OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
            PlanResolveEndpointAgentToolV2PlanResolvePostBody,
            PlanResolveEndpointAgentToolV2PlanResolvePostData,
            PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
            OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Plan Resolve Endpoint
     * @description Resolve the caller's words into a bookable service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.planResolveEndpointAgentToolV2PlanResolvePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PlanResolveEndpointAgentToolV2PlanResolvePostBody,
              PlanResolveEndpointAgentToolV2PlanResolvePostData,
              PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
              OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
              PlanResolveEndpointAgentToolV2PlanResolvePostBody,
              PlanResolveEndpointAgentToolV2PlanResolvePostData,
              PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
              OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
              TContext
            >
      ):
        | Mutation<
            PlanResolveEndpointAgentToolV2PlanResolvePostData,
            PlanResolveEndpointAgentToolV2PlanResolvePostError,
            MutationVariables<
              PlanResolveEndpointAgentToolV2PlanResolvePostBody,
              PlanResolveEndpointAgentToolV2PlanResolvePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PlanResolveEndpointAgentToolV2PlanResolvePostBody,
              PlanResolveEndpointAgentToolV2PlanResolvePostData,
              PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
              OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PlanResolveEndpointAgentToolV2PlanResolvePostSchema,
              PlanResolveEndpointAgentToolV2PlanResolvePostBody,
              PlanResolveEndpointAgentToolV2PlanResolvePostData,
              PlanResolveEndpointAgentToolV2PlanResolvePostParameters,
              OperationError<PlanResolveEndpointAgentToolV2PlanResolvePostError>,
              TContext
            >
      ): Array<
        Mutation<
          PlanResolveEndpointAgentToolV2PlanResolvePostData,
          PlanResolveEndpointAgentToolV2PlanResolvePostError,
          MutationVariables<
            PlanResolveEndpointAgentToolV2PlanResolvePostBody,
            PlanResolveEndpointAgentToolV2PlanResolvePostParameters
          >,
          TContext
        >
      >;
    };
    schema: PlanResolveEndpointAgentToolV2PlanResolvePostSchema;
    types: {
      parameters: PlanResolveEndpointAgentToolV2PlanResolvePostParameters;
      data: PlanResolveEndpointAgentToolV2PlanResolvePostData;
      error: PlanResolveEndpointAgentToolV2PlanResolvePostError;
      body: PlanResolveEndpointAgentToolV2PlanResolvePostBody;
    };
  };
  /**
   * @summary Availability List Endpoint
   * @description Times the caller can be seen, for the service already resolved on this call.
   */
  availabilityListEndpointAgentToolV2AvailabilityListPost: {
    /**
     * @summary Availability List Endpoint
     * @description Times the caller can be seen, for the service already resolved on this call.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
        AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
        options: ServiceOperationMutationFnOptions<
          AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
          AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
          AvailabilityListEndpointAgentToolV2AvailabilityListPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
        AvailabilityListEndpointAgentToolV2AvailabilityListPostError
      >
    >;
    /**
     * @summary Availability List Endpoint
     * @description Times the caller can be seen, for the service already resolved on this call.
     */
    getMutationKey(
      parameters: DeepReadonly<AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters> | void
    ): ServiceOperationMutationKey<
      AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
      AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Availability List Endpoint
     * @description Times the caller can be seen, for the service already resolved on this call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends AvailabilityListEndpointAgentToolV2AvailabilityListPostBody, TContext = unknown>(
      parameters: DeepReadonly<AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
        AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
        AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
        TVariables,
        OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
        TContext
      >
    ): UseMutationResult<
      AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
      OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Availability List Endpoint
     * @description Times the caller can be seen, for the service already resolved on this call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
        AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
        AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
        AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
        TVariables,
        OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
        TContext
      >
    ): UseMutationResult<
      AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
      OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Availability List Endpoint
     * @description Times the caller can be seen, for the service already resolved on this call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const availabilityListEndpointAgentToolV2AvailabilityListPostTotal = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const availabilityListEndpointAgentToolV2AvailabilityListPostTotal = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
            OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
            OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Availability List Endpoint
     * @description Times the caller can be seen, for the service already resolved on this call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const availabilityListEndpointAgentToolV2AvailabilityListPostPendingMutationVariables = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const availabilityListEndpointAgentToolV2AvailabilityListPostMutationData = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
        OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
        MutationVariables<
          AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
          AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
            OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
            OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
          OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
          MutationVariables<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Availability List Endpoint
     * @description Times the caller can be seen, for the service already resolved on this call.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
            OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
            OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Availability List Endpoint
     * @description Times the caller can be seen, for the service already resolved on this call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.availabilityListEndpointAgentToolV2AvailabilityListPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
              OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
              OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
              TContext
            >
      ):
        | Mutation<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostError,
            MutationVariables<
              AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
              OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
              AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters,
              OperationError<AvailabilityListEndpointAgentToolV2AvailabilityListPostError>,
              TContext
            >
      ): Array<
        Mutation<
          AvailabilityListEndpointAgentToolV2AvailabilityListPostData,
          AvailabilityListEndpointAgentToolV2AvailabilityListPostError,
          MutationVariables<
            AvailabilityListEndpointAgentToolV2AvailabilityListPostBody,
            AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters
          >,
          TContext
        >
      >;
    };
    schema: AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema;
    types: {
      parameters: AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters;
      data: AvailabilityListEndpointAgentToolV2AvailabilityListPostData;
      error: AvailabilityListEndpointAgentToolV2AvailabilityListPostError;
      body: AvailabilityListEndpointAgentToolV2AvailabilityListPostBody;
    };
  };
  /**
   * @summary Appointment Book Endpoint
   * @description Book a time this call offered.
   */
  appointmentBookEndpointAgentToolV2AppointmentBookPost: {
    /**
     * @summary Appointment Book Endpoint
     * @description Book a time this call offered.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
        AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
        options: ServiceOperationMutationFnOptions<
          AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
          AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
          AppointmentBookEndpointAgentToolV2AppointmentBookPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
        AppointmentBookEndpointAgentToolV2AppointmentBookPostError
      >
    >;
    /**
     * @summary Appointment Book Endpoint
     * @description Book a time this call offered.
     */
    getMutationKey(
      parameters: DeepReadonly<AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters> | void
    ): ServiceOperationMutationKey<
      AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
      AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Book Endpoint
     * @description Book a time this call offered.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends AppointmentBookEndpointAgentToolV2AppointmentBookPostBody, TContext = unknown>(
      parameters: DeepReadonly<AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
        AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
        AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
        TVariables,
        OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
      OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Book Endpoint
     * @description Book a time this call offered.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
        AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
        AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
        AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
        TVariables,
        OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
      OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Appointment Book Endpoint
     * @description Book a time this call offered.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const appointmentBookEndpointAgentToolV2AppointmentBookPostTotal = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const appointmentBookEndpointAgentToolV2AppointmentBookPostTotal = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
            OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
            OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Appointment Book Endpoint
     * @description Book a time this call offered.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const appointmentBookEndpointAgentToolV2AppointmentBookPostPendingMutationVariables = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const appointmentBookEndpointAgentToolV2AppointmentBookPostMutationData = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
        OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
        MutationVariables<
          AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
          AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
            OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
            OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
          OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
          MutationVariables<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Appointment Book Endpoint
     * @description Book a time this call offered.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
            OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
            OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Appointment Book Endpoint
     * @description Book a time this call offered.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentBookEndpointAgentToolV2AppointmentBookPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
              OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
              OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
              TContext
            >
      ):
        | Mutation<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostError,
            MutationVariables<
              AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
              OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
              AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters,
              OperationError<AppointmentBookEndpointAgentToolV2AppointmentBookPostError>,
              TContext
            >
      ): Array<
        Mutation<
          AppointmentBookEndpointAgentToolV2AppointmentBookPostData,
          AppointmentBookEndpointAgentToolV2AppointmentBookPostError,
          MutationVariables<
            AppointmentBookEndpointAgentToolV2AppointmentBookPostBody,
            AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters
          >,
          TContext
        >
      >;
    };
    schema: AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema;
    types: {
      parameters: AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters;
      data: AppointmentBookEndpointAgentToolV2AppointmentBookPostData;
      error: AppointmentBookEndpointAgentToolV2AppointmentBookPostError;
      body: AppointmentBookEndpointAgentToolV2AppointmentBookPostBody;
    };
  };
  /**
   * @summary Appointment Reschedule Endpoint
   * @description Move the appointment this call is about.
   */
  appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost: {
    /**
     * @summary Appointment Reschedule Endpoint
     * @description Move the appointment this call is about.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
        options: ServiceOperationMutationFnOptions<
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError
      >
    >;
    /**
     * @summary Appointment Reschedule Endpoint
     * @description Move the appointment this call is about.
     */
    getMutationKey(
      parameters: DeepReadonly<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters> | void
    ): ServiceOperationMutationKey<
      AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
      AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Reschedule Endpoint
     * @description Move the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
        TVariables,
        OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
      OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Reschedule Endpoint
     * @description Move the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
        TVariables,
        OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
      OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Appointment Reschedule Endpoint
     * @description Move the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostTotal = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostTotal = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
            OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
            OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Appointment Reschedule Endpoint
     * @description Move the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostPendingMutationVariables = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostMutationData = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
        OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
        MutationVariables<
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
            OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
            OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
          OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
          MutationVariables<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Appointment Reschedule Endpoint
     * @description Move the appointment this call is about.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
            OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
            OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Appointment Reschedule Endpoint
     * @description Move the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
              OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
              OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
              TContext
            >
      ):
        | Mutation<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError,
            MutationVariables<
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
              OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
              AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters,
              OperationError<AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError>,
              TContext
            >
      ): Array<
        Mutation<
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData,
          AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError,
          MutationVariables<
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody,
            AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters
          >,
          TContext
        >
      >;
    };
    schema: AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema;
    types: {
      parameters: AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters;
      data: AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData;
      error: AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError;
      body: AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody;
    };
  };
  /**
   * @summary Appointment Cancel Endpoint
   * @description Cancel the appointment this call is about.
   */
  appointmentCancelEndpointAgentToolV2AppointmentCancelPost: {
    /**
     * @summary Appointment Cancel Endpoint
     * @description Cancel the appointment this call is about.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
        options: ServiceOperationMutationFnOptions<
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError
      >
    >;
    /**
     * @summary Appointment Cancel Endpoint
     * @description Cancel the appointment this call is about.
     */
    getMutationKey(
      parameters: DeepReadonly<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters> | void
    ): ServiceOperationMutationKey<
      AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
      AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Cancel Endpoint
     * @description Cancel the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody, TContext = unknown>(
      parameters: DeepReadonly<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
        TVariables,
        OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
      OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Cancel Endpoint
     * @description Cancel the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
        TVariables,
        OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
      OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Appointment Cancel Endpoint
     * @description Cancel the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const appointmentCancelEndpointAgentToolV2AppointmentCancelPostTotal = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const appointmentCancelEndpointAgentToolV2AppointmentCancelPostTotal = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
            OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
            OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Appointment Cancel Endpoint
     * @description Cancel the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const appointmentCancelEndpointAgentToolV2AppointmentCancelPostPendingMutationVariables = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const appointmentCancelEndpointAgentToolV2AppointmentCancelPostMutationData = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
        OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
        MutationVariables<
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
            OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
            OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
          OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
          MutationVariables<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Appointment Cancel Endpoint
     * @description Cancel the appointment this call is about.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
            OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
            OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Appointment Cancel Endpoint
     * @description Cancel the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentCancelEndpointAgentToolV2AppointmentCancelPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
              OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
              OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
              TContext
            >
      ):
        | Mutation<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError,
            MutationVariables<
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
              OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
              AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters,
              OperationError<AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError>,
              TContext
            >
      ): Array<
        Mutation<
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData,
          AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError,
          MutationVariables<
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody,
            AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters
          >,
          TContext
        >
      >;
    };
    schema: AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema;
    types: {
      parameters: AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters;
      data: AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData;
      error: AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError;
      body: AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody;
    };
  };
  /**
   * @summary Appointment Note Endpoint
   * @description Add a note to the appointment this call is about.
   */
  appointmentNoteEndpointAgentToolV2AppointmentAddNotePost: {
    /**
     * @summary Appointment Note Endpoint
     * @description Add a note to the appointment this call is about.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
        options: ServiceOperationMutationFnOptions<
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError
      >
    >;
    /**
     * @summary Appointment Note Endpoint
     * @description Add a note to the appointment this call is about.
     */
    getMutationKey(
      parameters: DeepReadonly<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters> | void
    ): ServiceOperationMutationKey<
      AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
      AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Note Endpoint
     * @description Add a note to the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody, TContext = unknown>(
      parameters: DeepReadonly<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
        TVariables,
        OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
      OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Note Endpoint
     * @description Add a note to the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
        TVariables,
        OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
      OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Appointment Note Endpoint
     * @description Add a note to the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const appointmentNoteEndpointAgentToolV2AppointmentAddNotePostTotal = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const appointmentNoteEndpointAgentToolV2AppointmentAddNotePostTotal = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
            OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
            OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Appointment Note Endpoint
     * @description Add a note to the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const appointmentNoteEndpointAgentToolV2AppointmentAddNotePostPendingMutationVariables = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const appointmentNoteEndpointAgentToolV2AppointmentAddNotePostMutationData = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
        OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
        MutationVariables<
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
            OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
            OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
          OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
          MutationVariables<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Appointment Note Endpoint
     * @description Add a note to the appointment this call is about.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
            OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
            OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Appointment Note Endpoint
     * @description Add a note to the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentNoteEndpointAgentToolV2AppointmentAddNotePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
              OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
              OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
              TContext
            >
      ):
        | Mutation<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError,
            MutationVariables<
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
              OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
              AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters,
              OperationError<AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError>,
              TContext
            >
      ): Array<
        Mutation<
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData,
          AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError,
          MutationVariables<
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody,
            AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters
          >,
          TContext
        >
      >;
    };
    schema: AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema;
    types: {
      parameters: AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters;
      data: AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData;
      error: AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError;
      body: AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody;
    };
  };
  /**
   * @summary Appointment Confirm Arrival Window Endpoint
   * @description Confirm the arrival window for the appointment this call is about.
   */
  appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost: {
    /**
     * @summary Appointment Confirm Arrival Window Endpoint
     * @description Confirm the arrival window for the appointment this call is about.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
        options: ServiceOperationMutationFnOptions<
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError
      >
    >;
    /**
     * @summary Appointment Confirm Arrival Window Endpoint
     * @description Confirm the arrival window for the appointment this call is about.
     */
    getMutationKey(
      parameters: DeepReadonly<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters> | void
    ): ServiceOperationMutationKey<
      AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
      AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Confirm Arrival Window Endpoint
     * @description Confirm the arrival window for the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
        TVariables,
        OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
      OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment Confirm Arrival Window Endpoint
     * @description Confirm the arrival window for the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
        TVariables,
        OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
      OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Appointment Confirm Arrival Window Endpoint
     * @description Confirm the arrival window for the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostTotal = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostTotal = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
            OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
            OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Appointment Confirm Arrival Window Endpoint
     * @description Confirm the arrival window for the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostPendingMutationVariables = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostMutationData = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
        OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
        MutationVariables<
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
            OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
            OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
          OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
          MutationVariables<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Appointment Confirm Arrival Window Endpoint
     * @description Confirm the arrival window for the appointment this call is about.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
            OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
            OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Appointment Confirm Arrival Window Endpoint
     * @description Confirm the arrival window for the appointment this call is about.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
              OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
              OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
              TContext
            >
      ):
        | Mutation<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError,
            MutationVariables<
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
              OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
              AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters,
              OperationError<AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError>,
              TContext
            >
      ): Array<
        Mutation<
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData,
          AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError,
          MutationVariables<
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody,
            AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters
          >,
          TContext
        >
      >;
    };
    schema: AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema;
    types: {
      parameters: AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters;
      data: AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData;
      error: AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError;
      body: AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody;
    };
  };
  /**
   * @summary Appointment List Upcoming Endpoint
   * @description The caller's upcoming appointments.
   */
  appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost: {
    /**
     * @summary Appointment List Upcoming Endpoint
     * @description The caller's upcoming appointments.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
        options: ServiceOperationMutationFnOptions<
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError
      >
    >;
    /**
     * @summary Appointment List Upcoming Endpoint
     * @description The caller's upcoming appointments.
     */
    getMutationKey(
      parameters: DeepReadonly<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters> | void
    ): ServiceOperationMutationKey<
      AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
      AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment List Upcoming Endpoint
     * @description The caller's upcoming appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
        TVariables,
        OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
      OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment List Upcoming Endpoint
     * @description The caller's upcoming appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
        TVariables,
        OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
      OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Appointment List Upcoming Endpoint
     * @description The caller's upcoming appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostTotal = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostTotal = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
            OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
            OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Appointment List Upcoming Endpoint
     * @description The caller's upcoming appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostPendingMutationVariables = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostMutationData = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
        OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
        MutationVariables<
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
            OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
            OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
          OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
          MutationVariables<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Appointment List Upcoming Endpoint
     * @description The caller's upcoming appointments.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
            OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
            OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Appointment List Upcoming Endpoint
     * @description The caller's upcoming appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
              OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
              OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
              TContext
            >
      ):
        | Mutation<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError,
            MutationVariables<
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
              OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
              AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters,
              OperationError<AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError>,
              TContext
            >
      ): Array<
        Mutation<
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData,
          AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError,
          MutationVariables<
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody,
            AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters
          >,
          TContext
        >
      >;
    };
    schema: AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema;
    types: {
      parameters: AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters;
      data: AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData;
      error: AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError;
      body: AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody;
    };
  };
  /**
   * @summary Appointment List Past Endpoint
   * @description The caller's past appointments.
   */
  appointmentListPastEndpointAgentToolV2AppointmentListPastPost: {
    /**
     * @summary Appointment List Past Endpoint
     * @description The caller's past appointments.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
        options: ServiceOperationMutationFnOptions<
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError
      >
    >;
    /**
     * @summary Appointment List Past Endpoint
     * @description The caller's past appointments.
     */
    getMutationKey(
      parameters: DeepReadonly<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters> | void
    ): ServiceOperationMutationKey<
      AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
      AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment List Past Endpoint
     * @description The caller's past appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
        TVariables,
        OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
      OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Appointment List Past Endpoint
     * @description The caller's past appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
        TVariables,
        OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
        TContext
      >
    ): UseMutationResult<
      AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
      OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Appointment List Past Endpoint
     * @description The caller's past appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const appointmentListPastEndpointAgentToolV2AppointmentListPastPostTotal = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const appointmentListPastEndpointAgentToolV2AppointmentListPastPostTotal = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
            OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
            OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Appointment List Past Endpoint
     * @description The caller's past appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const appointmentListPastEndpointAgentToolV2AppointmentListPastPostPendingMutationVariables = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const appointmentListPastEndpointAgentToolV2AppointmentListPastPostMutationData = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
        OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
        MutationVariables<
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
            OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
            OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
          OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
          MutationVariables<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Appointment List Past Endpoint
     * @description The caller's past appointments.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
            OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
            OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Appointment List Past Endpoint
     * @description The caller's past appointments.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.appointmentListPastEndpointAgentToolV2AppointmentListPastPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
              OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
              OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
              TContext
            >
      ):
        | Mutation<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError,
            MutationVariables<
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
              OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
              AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters,
              OperationError<AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError>,
              TContext
            >
      ): Array<
        Mutation<
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData,
          AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError,
          MutationVariables<
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody,
            AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters
          >,
          TContext
        >
      >;
    };
    schema: AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema;
    types: {
      parameters: AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters;
      data: AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData;
      error: AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError;
      body: AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody;
    };
  };
  /**
   * @summary Customer Get By Phone Endpoint
   * @description Find an account by phone number.
   */
  customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost: {
    /**
     * @summary Customer Get By Phone Endpoint
     * @description Find an account by phone number.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
        options: ServiceOperationMutationFnOptions<
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError
      >
    >;
    /**
     * @summary Customer Get By Phone Endpoint
     * @description Find an account by phone number.
     */
    getMutationKey(
      parameters: DeepReadonly<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters> | void
    ): ServiceOperationMutationKey<
      CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
      CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Customer Get By Phone Endpoint
     * @description Find an account by phone number.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody, TContext = unknown>(
      parameters: DeepReadonly<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
        TVariables,
        OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
        TContext
      >
    ): UseMutationResult<
      CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
      OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Customer Get By Phone Endpoint
     * @description Find an account by phone number.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
        TVariables,
        OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
        TContext
      >
    ): UseMutationResult<
      CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
      OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Customer Get By Phone Endpoint
     * @description Find an account by phone number.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostTotal = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostTotal = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
            OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
            OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Customer Get By Phone Endpoint
     * @description Find an account by phone number.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostPendingMutationVariables = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostMutationData = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
        OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
        MutationVariables<
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
            OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
            OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
          OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
          MutationVariables<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Customer Get By Phone Endpoint
     * @description Find an account by phone number.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
            OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
            OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Customer Get By Phone Endpoint
     * @description Find an account by phone number.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
              OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
              OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
              TContext
            >
      ):
        | Mutation<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError,
            MutationVariables<
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
              OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
              CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters,
              OperationError<CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError>,
              TContext
            >
      ): Array<
        Mutation<
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData,
          CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError,
          MutationVariables<
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody,
            CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters
          >,
          TContext
        >
      >;
    };
    schema: CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema;
    types: {
      parameters: CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters;
      data: CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData;
      error: CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError;
      body: CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody;
    };
  };
  /**
   * @summary Customer Get By Address Endpoint
   * @description Find an account by service address.
   */
  customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost: {
    /**
     * @summary Customer Get By Address Endpoint
     * @description Find an account by service address.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
        options: ServiceOperationMutationFnOptions<
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError
      >
    >;
    /**
     * @summary Customer Get By Address Endpoint
     * @description Find an account by service address.
     */
    getMutationKey(
      parameters: DeepReadonly<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters> | void
    ): ServiceOperationMutationKey<
      CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
      CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Customer Get By Address Endpoint
     * @description Find an account by service address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
        TVariables,
        OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
        TContext
      >
    ): UseMutationResult<
      CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
      OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Customer Get By Address Endpoint
     * @description Find an account by service address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
        TVariables,
        OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
        TContext
      >
    ): UseMutationResult<
      CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
      OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Customer Get By Address Endpoint
     * @description Find an account by service address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostTotal = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostTotal = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
            OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
            OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Customer Get By Address Endpoint
     * @description Find an account by service address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostPendingMutationVariables = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostMutationData = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
        OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
        MutationVariables<
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
            OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
            OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
          OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
          MutationVariables<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Customer Get By Address Endpoint
     * @description Find an account by service address.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
            OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
            OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Customer Get By Address Endpoint
     * @description Find an account by service address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
              OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
              OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
              TContext
            >
      ):
        | Mutation<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError,
            MutationVariables<
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
              OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
              CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters,
              OperationError<CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData,
          CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError,
          MutationVariables<
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody,
            CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema;
    types: {
      parameters: CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters;
      data: CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData;
      error: CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError;
      body: CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody;
    };
  };
  /**
   * @summary Customer Get By Zipcode Endpoint
   * @description List accounts in a ZIP code.
   */
  customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost: {
    /**
     * @summary Customer Get By Zipcode Endpoint
     * @description List accounts in a ZIP code.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
        options: ServiceOperationMutationFnOptions<
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError
      >
    >;
    /**
     * @summary Customer Get By Zipcode Endpoint
     * @description List accounts in a ZIP code.
     */
    getMutationKey(
      parameters: DeepReadonly<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters> | void
    ): ServiceOperationMutationKey<
      CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
      CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Customer Get By Zipcode Endpoint
     * @description List accounts in a ZIP code.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
        TVariables,
        OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
        TContext
      >
    ): UseMutationResult<
      CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
      OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Customer Get By Zipcode Endpoint
     * @description List accounts in a ZIP code.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
        TVariables,
        OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
        TContext
      >
    ): UseMutationResult<
      CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
      OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Customer Get By Zipcode Endpoint
     * @description List accounts in a ZIP code.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostTotal = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostTotal = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
            OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
            OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Customer Get By Zipcode Endpoint
     * @description List accounts in a ZIP code.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostPendingMutationVariables = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostMutationData = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
        OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
        MutationVariables<
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
            OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
            OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
          OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
          MutationVariables<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Customer Get By Zipcode Endpoint
     * @description List accounts in a ZIP code.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
            OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
            OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Customer Get By Zipcode Endpoint
     * @description List accounts in a ZIP code.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
              OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
              OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
              TContext
            >
      ):
        | Mutation<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError,
            MutationVariables<
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
              OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
              CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters,
              OperationError<CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError>,
              TContext
            >
      ): Array<
        Mutation<
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData,
          CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError,
          MutationVariables<
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody,
            CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters
          >,
          TContext
        >
      >;
    };
    schema: CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema;
    types: {
      parameters: CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters;
      data: CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData;
      error: CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError;
      body: CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody;
    };
  };
  /**
   * @summary Customer Create Endpoint
   * @description Create an account for the caller.
   */
  customerCreateEndpointAgentToolV2CustomerCreatePost: {
    /**
     * @summary Customer Create Endpoint
     * @description Create an account for the caller.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
        CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
        options: ServiceOperationMutationFnOptions<
          CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
          CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
          CustomerCreateEndpointAgentToolV2CustomerCreatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
        CustomerCreateEndpointAgentToolV2CustomerCreatePostError
      >
    >;
    /**
     * @summary Customer Create Endpoint
     * @description Create an account for the caller.
     */
    getMutationKey(
      parameters: DeepReadonly<CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters> | void
    ): ServiceOperationMutationKey<
      CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
      CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Customer Create Endpoint
     * @description Create an account for the caller.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CustomerCreateEndpointAgentToolV2CustomerCreatePostBody, TContext = unknown>(
      parameters: DeepReadonly<CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
        CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
        CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
        TVariables,
        OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
        TContext
      >
    ): UseMutationResult<
      CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
      OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Customer Create Endpoint
     * @description Create an account for the caller.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
        CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
        CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
        CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
        TVariables,
        OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
        TContext
      >
    ): UseMutationResult<
      CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
      OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Customer Create Endpoint
     * @description Create an account for the caller.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const customerCreateEndpointAgentToolV2CustomerCreatePostTotal = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const customerCreateEndpointAgentToolV2CustomerCreatePostTotal = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
            OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
            OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Customer Create Endpoint
     * @description Create an account for the caller.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const customerCreateEndpointAgentToolV2CustomerCreatePostPendingMutationVariables = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const customerCreateEndpointAgentToolV2CustomerCreatePostMutationData = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
        OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
        MutationVariables<
          CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
          CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
            OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
            OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
          OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
          MutationVariables<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Customer Create Endpoint
     * @description Create an account for the caller.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
            OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
            OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Customer Create Endpoint
     * @description Create an account for the caller.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.customerCreateEndpointAgentToolV2CustomerCreatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
              OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
              OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
              TContext
            >
      ):
        | Mutation<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostError,
            MutationVariables<
              CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
              OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
              CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters,
              OperationError<CustomerCreateEndpointAgentToolV2CustomerCreatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          CustomerCreateEndpointAgentToolV2CustomerCreatePostData,
          CustomerCreateEndpointAgentToolV2CustomerCreatePostError,
          MutationVariables<
            CustomerCreateEndpointAgentToolV2CustomerCreatePostBody,
            CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema;
    types: {
      parameters: CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters;
      data: CustomerCreateEndpointAgentToolV2CustomerCreatePostData;
      error: CustomerCreateEndpointAgentToolV2CustomerCreatePostError;
      body: CustomerCreateEndpointAgentToolV2CustomerCreatePostBody;
    };
  };
  /**
   * @summary Escalation Create Endpoint
   * @description Flag the call for a human.
   */
  escalationCreateEndpointAgentToolV2EscalationCreatePost: {
    /**
     * @summary Escalation Create Endpoint
     * @description Flag the call for a human.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
        EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
        options: ServiceOperationMutationFnOptions<
          EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
          EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
          EscalationCreateEndpointAgentToolV2EscalationCreatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
        EscalationCreateEndpointAgentToolV2EscalationCreatePostError
      >
    >;
    /**
     * @summary Escalation Create Endpoint
     * @description Flag the call for a human.
     */
    getMutationKey(
      parameters: DeepReadonly<EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters> | void
    ): ServiceOperationMutationKey<
      EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
      EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Escalation Create Endpoint
     * @description Flag the call for a human.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends EscalationCreateEndpointAgentToolV2EscalationCreatePostBody, TContext = unknown>(
      parameters: DeepReadonly<EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
        EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
        EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
        TVariables,
        OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
        TContext
      >
    ): UseMutationResult<
      EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
      OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Escalation Create Endpoint
     * @description Flag the call for a human.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
        EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
        EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
        EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
        TVariables,
        OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
        TContext
      >
    ): UseMutationResult<
      EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
      OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Escalation Create Endpoint
     * @description Flag the call for a human.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const escalationCreateEndpointAgentToolV2EscalationCreatePostTotal = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const escalationCreateEndpointAgentToolV2EscalationCreatePostTotal = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
            OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
            OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Escalation Create Endpoint
     * @description Flag the call for a human.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const escalationCreateEndpointAgentToolV2EscalationCreatePostPendingMutationVariables = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const escalationCreateEndpointAgentToolV2EscalationCreatePostMutationData = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
        OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
        MutationVariables<
          EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
          EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
            OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
            OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
          OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
          MutationVariables<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Escalation Create Endpoint
     * @description Flag the call for a human.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
            OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
            OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Escalation Create Endpoint
     * @description Flag the call for a human.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsV2Service.escalationCreateEndpointAgentToolV2EscalationCreatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
              OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
              OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
              TContext
            >
      ):
        | Mutation<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostError,
            MutationVariables<
              EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
              OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
              EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters,
              OperationError<EscalationCreateEndpointAgentToolV2EscalationCreatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          EscalationCreateEndpointAgentToolV2EscalationCreatePostData,
          EscalationCreateEndpointAgentToolV2EscalationCreatePostError,
          MutationVariables<
            EscalationCreateEndpointAgentToolV2EscalationCreatePostBody,
            EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema;
    types: {
      parameters: EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters;
      data: EscalationCreateEndpointAgentToolV2EscalationCreatePostData;
      error: EscalationCreateEndpointAgentToolV2EscalationCreatePostError;
      body: EscalationCreateEndpointAgentToolV2EscalationCreatePostBody;
    };
  };
}
/**
 * @summary Plan Resolve Endpoint
 * @description Resolve the caller's words into a bookable service.
 */
export const planResolveEndpointAgentToolV2PlanResolvePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/plan/resolve',
    mediaType: ['application/json'],
  },
} as {
  schema: PlanResolveEndpointAgentToolV2PlanResolvePostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['planResolveEndpointAgentToolV2PlanResolvePost'];
};
/**
 * @summary Availability List Endpoint
 * @description Times the caller can be seen, for the service already resolved on this call.
 */
export const availabilityListEndpointAgentToolV2AvailabilityListPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/availability/list',
    mediaType: ['application/json'],
  },
} as {
  schema: AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['availabilityListEndpointAgentToolV2AvailabilityListPost'];
};
/**
 * @summary Appointment Book Endpoint
 * @description Book a time this call offered.
 */
export const appointmentBookEndpointAgentToolV2AppointmentBookPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/appointment/book',
    mediaType: ['application/json'],
  },
} as {
  schema: AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['appointmentBookEndpointAgentToolV2AppointmentBookPost'];
};
/**
 * @summary Appointment Reschedule Endpoint
 * @description Move the appointment this call is about.
 */
export const appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/appointment/reschedule',
    mediaType: ['application/json'],
  },
} as {
  schema: AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost'];
};
/**
 * @summary Appointment Cancel Endpoint
 * @description Cancel the appointment this call is about.
 */
export const appointmentCancelEndpointAgentToolV2AppointmentCancelPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/appointment/cancel',
    mediaType: ['application/json'],
  },
} as {
  schema: AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['appointmentCancelEndpointAgentToolV2AppointmentCancelPost'];
};
/**
 * @summary Appointment Note Endpoint
 * @description Add a note to the appointment this call is about.
 */
export const appointmentNoteEndpointAgentToolV2AppointmentAddNotePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/appointment/add_note',
    mediaType: ['application/json'],
  },
} as {
  schema: AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['appointmentNoteEndpointAgentToolV2AppointmentAddNotePost'];
};
/**
 * @summary Appointment Confirm Arrival Window Endpoint
 * @description Confirm the arrival window for the appointment this call is about.
 */
export const appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/appointment/confirm_arrival_window',
    mediaType: ['application/json'],
  },
} as {
  schema: AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost'];
};
/**
 * @summary Appointment List Upcoming Endpoint
 * @description The caller's upcoming appointments.
 */
export const appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/appointment/list_upcoming',
    mediaType: ['application/json'],
  },
} as {
  schema: AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost'];
};
/**
 * @summary Appointment List Past Endpoint
 * @description The caller's past appointments.
 */
export const appointmentListPastEndpointAgentToolV2AppointmentListPastPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/appointment/list_past',
    mediaType: ['application/json'],
  },
} as {
  schema: AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['appointmentListPastEndpointAgentToolV2AppointmentListPastPost'];
};
/**
 * @summary Customer Get By Phone Endpoint
 * @description Find an account by phone number.
 */
export const customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/customer/get_by_phone',
    mediaType: ['application/json'],
  },
} as {
  schema: CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost'];
};
/**
 * @summary Customer Get By Address Endpoint
 * @description Find an account by service address.
 */
export const customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/customer/get_by_address',
    mediaType: ['application/json'],
  },
} as {
  schema: CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost'];
};
/**
 * @summary Customer Get By Zipcode Endpoint
 * @description List accounts in a ZIP code.
 */
export const customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/customer/get_by_zipcode',
    mediaType: ['application/json'],
  },
} as {
  schema: CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost'];
};
/**
 * @summary Customer Create Endpoint
 * @description Create an account for the caller.
 */
export const customerCreateEndpointAgentToolV2CustomerCreatePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/customer/create',
    mediaType: ['application/json'],
  },
} as {
  schema: CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['customerCreateEndpointAgentToolV2CustomerCreatePost'];
};
/**
 * @summary Escalation Create Endpoint
 * @description Flag the call for a human.
 */
export const escalationCreateEndpointAgentToolV2EscalationCreatePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/v2/escalation/create',
    mediaType: ['application/json'],
  },
} as {
  schema: EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema;
  [QraftServiceOperationsToken]: AgentToolsV2Service['escalationCreateEndpointAgentToolV2EscalationCreatePost'];
};
export const agentToolsV2Service = {
  planResolveEndpointAgentToolV2PlanResolvePost,
  availabilityListEndpointAgentToolV2AvailabilityListPost,
  appointmentBookEndpointAgentToolV2AppointmentBookPost,
  appointmentRescheduleEndpointAgentToolV2AppointmentReschedulePost,
  appointmentCancelEndpointAgentToolV2AppointmentCancelPost,
  appointmentNoteEndpointAgentToolV2AppointmentAddNotePost,
  appointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPost,
  appointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPost,
  appointmentListPastEndpointAgentToolV2AppointmentListPastPost,
  customerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePost,
  customerGetByAddressEndpointAgentToolV2CustomerGetByAddressPost,
  customerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePost,
  customerCreateEndpointAgentToolV2CustomerCreatePost,
  escalationCreateEndpointAgentToolV2EscalationCreatePost,
} as const;
type PlanResolveEndpointAgentToolV2PlanResolvePostSchema = {
  method: 'post';
  url: '/agent/tool/v2/plan/resolve';
  mediaType: ['application/json'];
};
type PlanResolveEndpointAgentToolV2PlanResolvePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type PlanResolveEndpointAgentToolV2PlanResolvePostData =
  paths['/agent/tool/v2/plan/resolve']['post']['responses']['200']['content']['application/json'];
type PlanResolveEndpointAgentToolV2PlanResolvePostError =
  paths['/agent/tool/v2/plan/resolve']['post']['responses']['422']['content']['application/json'];
type PlanResolveEndpointAgentToolV2PlanResolvePostBody =
  paths['/agent/tool/v2/plan/resolve']['post']['requestBody']['content']['application/json'];
type AvailabilityListEndpointAgentToolV2AvailabilityListPostSchema = {
  method: 'post';
  url: '/agent/tool/v2/availability/list';
  mediaType: ['application/json'];
};
type AvailabilityListEndpointAgentToolV2AvailabilityListPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AvailabilityListEndpointAgentToolV2AvailabilityListPostData =
  paths['/agent/tool/v2/availability/list']['post']['responses']['200']['content']['application/json'];
type AvailabilityListEndpointAgentToolV2AvailabilityListPostError =
  paths['/agent/tool/v2/availability/list']['post']['responses']['422']['content']['application/json'];
type AvailabilityListEndpointAgentToolV2AvailabilityListPostBody =
  paths['/agent/tool/v2/availability/list']['post']['requestBody']['content']['application/json'];
type AppointmentBookEndpointAgentToolV2AppointmentBookPostSchema = {
  method: 'post';
  url: '/agent/tool/v2/appointment/book';
  mediaType: ['application/json'];
};
type AppointmentBookEndpointAgentToolV2AppointmentBookPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AppointmentBookEndpointAgentToolV2AppointmentBookPostData =
  paths['/agent/tool/v2/appointment/book']['post']['responses']['200']['content']['application/json'];
type AppointmentBookEndpointAgentToolV2AppointmentBookPostError =
  paths['/agent/tool/v2/appointment/book']['post']['responses']['422']['content']['application/json'];
type AppointmentBookEndpointAgentToolV2AppointmentBookPostBody =
  paths['/agent/tool/v2/appointment/book']['post']['requestBody']['content']['application/json'];
type AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostSchema = {
  method: 'post';
  url: '/agent/tool/v2/appointment/reschedule';
  mediaType: ['application/json'];
};
type AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostData =
  paths['/agent/tool/v2/appointment/reschedule']['post']['responses']['200']['content']['application/json'];
type AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostError =
  paths['/agent/tool/v2/appointment/reschedule']['post']['responses']['422']['content']['application/json'];
type AppointmentRescheduleEndpointAgentToolV2AppointmentReschedulePostBody =
  paths['/agent/tool/v2/appointment/reschedule']['post']['requestBody']['content']['application/json'];
type AppointmentCancelEndpointAgentToolV2AppointmentCancelPostSchema = {
  method: 'post';
  url: '/agent/tool/v2/appointment/cancel';
  mediaType: ['application/json'];
};
type AppointmentCancelEndpointAgentToolV2AppointmentCancelPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AppointmentCancelEndpointAgentToolV2AppointmentCancelPostData =
  paths['/agent/tool/v2/appointment/cancel']['post']['responses']['200']['content']['application/json'];
type AppointmentCancelEndpointAgentToolV2AppointmentCancelPostError =
  paths['/agent/tool/v2/appointment/cancel']['post']['responses']['422']['content']['application/json'];
type AppointmentCancelEndpointAgentToolV2AppointmentCancelPostBody =
  paths['/agent/tool/v2/appointment/cancel']['post']['requestBody']['content']['application/json'];
type AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostSchema = {
  method: 'post';
  url: '/agent/tool/v2/appointment/add_note';
  mediaType: ['application/json'];
};
type AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostData =
  paths['/agent/tool/v2/appointment/add_note']['post']['responses']['200']['content']['application/json'];
type AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostError =
  paths['/agent/tool/v2/appointment/add_note']['post']['responses']['422']['content']['application/json'];
type AppointmentNoteEndpointAgentToolV2AppointmentAddNotePostBody =
  paths['/agent/tool/v2/appointment/add_note']['post']['requestBody']['content']['application/json'];
type AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostSchema = {
  method: 'post';
  url: '/agent/tool/v2/appointment/confirm_arrival_window';
  mediaType: ['application/json'];
};
type AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostData =
  paths['/agent/tool/v2/appointment/confirm_arrival_window']['post']['responses']['200']['content']['application/json'];
type AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostError =
  paths['/agent/tool/v2/appointment/confirm_arrival_window']['post']['responses']['422']['content']['application/json'];
type AppointmentConfirmArrivalWindowEndpointAgentToolV2AppointmentConfirmArrivalWindowPostBody =
  paths['/agent/tool/v2/appointment/confirm_arrival_window']['post']['requestBody']['content']['application/json'];
type AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostSchema = {
  method: 'post';
  url: '/agent/tool/v2/appointment/list_upcoming';
  mediaType: ['application/json'];
};
type AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostData =
  paths['/agent/tool/v2/appointment/list_upcoming']['post']['responses']['200']['content']['application/json'];
type AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostError =
  paths['/agent/tool/v2/appointment/list_upcoming']['post']['responses']['422']['content']['application/json'];
type AppointmentListUpcomingEndpointAgentToolV2AppointmentListUpcomingPostBody =
  paths['/agent/tool/v2/appointment/list_upcoming']['post']['requestBody']['content']['application/json'];
type AppointmentListPastEndpointAgentToolV2AppointmentListPastPostSchema = {
  method: 'post';
  url: '/agent/tool/v2/appointment/list_past';
  mediaType: ['application/json'];
};
type AppointmentListPastEndpointAgentToolV2AppointmentListPastPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AppointmentListPastEndpointAgentToolV2AppointmentListPastPostData =
  paths['/agent/tool/v2/appointment/list_past']['post']['responses']['200']['content']['application/json'];
type AppointmentListPastEndpointAgentToolV2AppointmentListPastPostError =
  paths['/agent/tool/v2/appointment/list_past']['post']['responses']['422']['content']['application/json'];
type AppointmentListPastEndpointAgentToolV2AppointmentListPastPostBody =
  paths['/agent/tool/v2/appointment/list_past']['post']['requestBody']['content']['application/json'];
type CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostSchema = {
  method: 'post';
  url: '/agent/tool/v2/customer/get_by_phone';
  mediaType: ['application/json'];
};
type CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostData =
  paths['/agent/tool/v2/customer/get_by_phone']['post']['responses']['200']['content']['application/json'];
type CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostError =
  paths['/agent/tool/v2/customer/get_by_phone']['post']['responses']['422']['content']['application/json'];
type CustomerGetByPhoneEndpointAgentToolV2CustomerGetByPhonePostBody =
  paths['/agent/tool/v2/customer/get_by_phone']['post']['requestBody']['content']['application/json'];
type CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostSchema = {
  method: 'post';
  url: '/agent/tool/v2/customer/get_by_address';
  mediaType: ['application/json'];
};
type CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostData =
  paths['/agent/tool/v2/customer/get_by_address']['post']['responses']['200']['content']['application/json'];
type CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostError =
  paths['/agent/tool/v2/customer/get_by_address']['post']['responses']['422']['content']['application/json'];
type CustomerGetByAddressEndpointAgentToolV2CustomerGetByAddressPostBody =
  paths['/agent/tool/v2/customer/get_by_address']['post']['requestBody']['content']['application/json'];
type CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostSchema = {
  method: 'post';
  url: '/agent/tool/v2/customer/get_by_zipcode';
  mediaType: ['application/json'];
};
type CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostData =
  paths['/agent/tool/v2/customer/get_by_zipcode']['post']['responses']['200']['content']['application/json'];
type CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostError =
  paths['/agent/tool/v2/customer/get_by_zipcode']['post']['responses']['422']['content']['application/json'];
type CustomerGetByZipcodeEndpointAgentToolV2CustomerGetByZipcodePostBody =
  paths['/agent/tool/v2/customer/get_by_zipcode']['post']['requestBody']['content']['application/json'];
type CustomerCreateEndpointAgentToolV2CustomerCreatePostSchema = {
  method: 'post';
  url: '/agent/tool/v2/customer/create';
  mediaType: ['application/json'];
};
type CustomerCreateEndpointAgentToolV2CustomerCreatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CustomerCreateEndpointAgentToolV2CustomerCreatePostData =
  paths['/agent/tool/v2/customer/create']['post']['responses']['200']['content']['application/json'];
type CustomerCreateEndpointAgentToolV2CustomerCreatePostError =
  paths['/agent/tool/v2/customer/create']['post']['responses']['422']['content']['application/json'];
type CustomerCreateEndpointAgentToolV2CustomerCreatePostBody =
  paths['/agent/tool/v2/customer/create']['post']['requestBody']['content']['application/json'];
type EscalationCreateEndpointAgentToolV2EscalationCreatePostSchema = {
  method: 'post';
  url: '/agent/tool/v2/escalation/create';
  mediaType: ['application/json'];
};
type EscalationCreateEndpointAgentToolV2EscalationCreatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type EscalationCreateEndpointAgentToolV2EscalationCreatePostData =
  paths['/agent/tool/v2/escalation/create']['post']['responses']['200']['content']['application/json'];
type EscalationCreateEndpointAgentToolV2EscalationCreatePostError =
  paths['/agent/tool/v2/escalation/create']['post']['responses']['422']['content']['application/json'];
type EscalationCreateEndpointAgentToolV2EscalationCreatePostBody =
  paths['/agent/tool/v2/escalation/create']['post']['requestBody']['content']['application/json'];
